import type { TopSellersPeriod } from '@/api/types'

export const TOP_SELLERS_PERIODS: TopSellersPeriod[] = ['month', 'week']

export const DEFAULT_TOP_SELLERS_PERIOD: TopSellersPeriod = 'month'

export const TOP_SELLERS_PERIOD_LABELS: Record<TopSellersPeriod, string> = {
  month: 'Månad',
  week: 'Vecka'
}

export const TOP_SELLERS_PERIOD_DESCRIPTIONS: Record<TopSellersPeriod, string> = {
  month: 'Flest nya kunder den här månaden.',
  week: 'Flest nya kunder den här veckan.'
}

export const TOP_SELLERS_PERIOD_EMPTY_MESSAGES: Record<TopSellersPeriod, string> = {
  month: 'Inga sälj den här månaden.',
  week: 'Inga sälj den här veckan.'
}
